<template>
  <v-card
    id="taches"
    fluid
  >

  <template>
  <v-data-table
    :headers="headers"
    :items="data_table"
    :items-per-page="10"
    class="elevation-1"
  >
  <template v-slot:top>
    <v-toolbar flat>
      <v-toolbar-title></v-toolbar-title>

        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>


        <v-spacer></v-spacer>
                  
        <v-dialog v-model="dialogue_ADD" width="1000">
          <v-card>
            <v-card-title class="headline">



              <v-row>
                <v-col cols="4">
                  <v-text-field
                    v-model="ligne.name"
                    label="Name"
                    class="required"
                  >4</v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="ligne.fname"
                    label="file Name"
                    class="required"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="ligne.type"
                    label="type"
                    class="required"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="4">
                  <v-text-field
                    v-model="ligne.jour"
                    label="Jour"
                    class="required"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="ligne.nuit"
                    label="nuit"
                    class="required"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="4">
                  <v-text-field
                    v-model="ligne.sha1_file"
                    label="sha1 file"
                    class="required"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="ligne.md5_data"
                    label="md5 data"
                    class="required"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">

                </v-col>
              </v-row>

              <v-row>
                <v-col cols="4">
                  <v-text-field
                    v-model="ligne.sha1_file_chet"
                    label="sha1 file Chet"
                    class="required"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="ligne.md5_data_chet"
                    label="md5 data Chet"
                    class="required"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">

                </v-col>
              </v-row>


            <v-spacer></v-spacer>

              <v-btn 
                  :loading="v_loading" 
                  color="success" 
                  text
                  :disabled="  !(
                      true
                    )"
                  @click="Save_Item">Save</v-btn>


              <v-btn color="error" text @click="dialogue_ADD = false">Cancel</v-btn>              

            </v-card-title>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogue_EDIT" width="1000">
          <v-card>
            <v-card-title class="headline">



              <v-row>
                <v-col cols="4">
                  <v-text-field
                    v-model="ligne.name"
                    label="Name"
                    class="required"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="ligne.fname"
                    label="file Name"
                    class="required"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="ligne.type"
                    label="type"
                    class="required"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="4">
                  <v-text-field
                    v-model="ligne.jour"
                    label="Jour"
                    class="required"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="ligne.nuit"
                    label="nuit"
                    class="required"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="4">
                  <v-text-field
                    v-model="ligne.sha1_file"
                    label="sha1 file"
                    class="required"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="ligne.md5_data"
                    label="md5 data"
                    class="required"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">

                </v-col>
              </v-row>

              <v-row>
                <v-col cols="4">
                  <v-text-field
                    v-model="ligne.sha1_file_chet"
                    label="sha1 file Chet"
                    class="required"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="ligne.md5_data_chet"
                    label="md5 data Chet"
                    class="required"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">

                </v-col>
              </v-row>
              <v-spacer></v-spacer>

              <v-btn 
                  :loading="v_loading" 
                  color="success" 
                  text
                  :disabled="  !(
                      true
                    )"
                  @click="Update_Item">Save</v-btn>


              <v-btn color="error" text @click="dialogue_EDIT = false">Cancel</v-btn>              

            </v-card-title>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialog"
          max-width="500px"
          :retain-focus="false"
        >
          <template  v-slot:activator="{}">

          
            <v-icon
              color="blue darken-3"
              class="ma-2"
              @click="Add_Item()"
            >mdi-plus-circle     
            </v-icon>

          </template>
        </v-dialog>
      </v-toolbar>
    </template>

    <template v-slot:[`item.actions`]="{ item }">


      <v-icon 
        v-if="true"
        small
        color="success"
        class="ma-2"
        @click="Edit_Item(item)"
        >mdi-pencil
      </v-icon>

      <v-icon
      v-if="true"
        small
        color="error"
        class="ma-2"
        @click="Delete_Item(item)"
        >mdi-delete
      </v-icon>


      <v-dialog v-model="dialogue_DELETE"
        max-width="1000px"
        style="z-index: 1000"
        :retain-focus="false"
      >
        <v-card flat>
          
          <v-card-title>
            
            <span class="headline" >Do you really want to remove this Line ?
            </span>

          </v-card-title>
          <v-card-actions>

            <v-spacer></v-spacer>

            <v-btn 
              color="success"
              class="ma-2"
              dark
              @click="Close_Item()"
              >Cancel
            </v-btn>

            <v-btn
              color="error"
              class="ma-2"
              dark
              @click="Delete_ThisItem()"
              >Yes
            </v-btn>
                          
          </v-card-actions>
          
        </v-card>
      </v-dialog>

    </template>

    <template>


    </template>



  </v-data-table>






</template>

</v-card>
</template>
<script>
  

  


  export default {

    data: () =>({

      texte_test :"tête vide",
      dialog : false,

      dialogue_ADD : false,
      dialogue_EDIT : false,
      dialogue_DELETE : false,

      filter :"",
      c_niveau : ["0","1","2","3","4","5","6","7","8"],
      c_type : ["Observations","Réduction","Transfert","Warning","Fatal","Réseau"],
      c_action : ["Rien","Réveiller tout le monde","Evacuer","Aller dormir","Keep Cool"],
      c_cmd : ["MAKE_RAW_NIGHT_MISS","NOP"],

      headers: [
          { text: 'id', value: 'id' },
          { text: 'nom', value: 'name' },
          { text: 'fname', value: 'fname' },
          { text: 'jour', value: 'jour' },
          { text: 'nuit', value: 'nuit' },
          { text: 'sha1', value: 'sha1_file' },
          { text: 'sha1 chet', value: 'sha1_file_chet' },
          { text: 'md5 data', value: 'md5_data' },
          { text: 'md5 data chet', value: 'md5_data_chet' },        
          { text: 'type', value: 'type' },
          { text: 'Actions', value: 'actions' }



        ],
      title : "ACQ Files",
      N_Dernieres : 1,

     
      ligne_base:{
        "id":-1,
        "name":"",
        "fname":"",
        "jour":"",
        "nuit":"",
        "sha1_file":"",
        "md5_data":"",
        "sha1_file_chet":"",
        "md5_data_chet":"",
        "type":""
      },

      ligne:{
        "id":-1,
        "name":"",
        "fname":"",
        "jour":"",
        "nuit":"",
        "sha1_file":"",
        "md5_data":"",
        "sha1_file_chet":"",
        "md5_data_chet":"",
        "type":""
      },


      criticite:{
        "id":-1,
        "nom":"",
        "niveau":"9",
        "type":"Warning",
        "action":"Rien",
        "notes":""
      },


      data_table_t :[],
      data_table :[],

      params:"",


      v_loading : false

    }),
  initialize(){

  },
  created(){
    
  },
  beforeMount(){
     

  },
  mounted(){

    this.Load_Table_liste();
    this.Set_Table_liste();
    this.A_Update_Item = setInterval(() => {
      this.Load_Table_liste();
      this.Set_Table_liste();
    },2000);
  },

  methods: {
    Tache_Pistache(){



      
      const othis=this;

      var url = backend_url + "/SYS1/neo_acq_f/";

      this.axios.post(url,this.tmp)
        .then((res) => {
        })
        .catch((error) => {
          console.log("err");
          console.error(error);

        });




    },
    Load_Table_liste(){

      const othis = this;

      this.axios.get( backend_url+ "/SYS1/neo_acq_f/",{})
      .then((res) => {

        
          othis.data_table_t = JSON.parse(JSON.stringify(res.data));
          this.data_table = JSON.parse(JSON.stringify(othis.data_table_t));
      })
      .catch(() => {
        console.log("PB au chargement de la table");
      });

    },
    Set_Table_liste(){

      this.data_table = JSON.parse(JSON.stringify(this.data_table_t));
 
    },  

    Add_Item(){
      this.ligne = JSON.parse(JSON.stringify(this.ligne_base));
      this.dialogue_ADD = true;
      this.dialogue_EDIT = false;
      this.dialogue_DELETE = false
    },
    Close_Item(){
      dialogue_ADD = false;
      dialogue_EDIT = false;
      dialogue_DELETE = false;
    },

    Delete_Item(item){

      this.ligne= item;
      this.dialogue_DELETE = true;

    },
    Edit_Item(item){

      this.ligne = item;
      this.dialogue_EDIT= true;

    },
    Delete_ThisItem(){

      const othis = this;

      this.axios.delete( backend_url +"/SYS1/neo_acq_f/delete/"+othis.ligne.id,{})
      .then((res) => {

          othis.data_table_t = JSON.parse(JSON.stringify(res.data));
          this.data_table = JSON.parse(JSON.stringify(othis.data_table_t));

          this.dialogue_DELETE = false;
      })
      .catch(() => {
        console.log("PB  suppréssion d'un Item");
        this.dialogue_DELETE = false;
      });
      
    },

    Save_Item(){

      const othis = this;

      this.axios.post( backend_url+"/SYS1/neo_acq_f/create",this.ligne)
      .then((res) => {
          console.log(res.data);
          othis.data_table_t = JSON.parse(JSON.stringify(res.data));
          this.data_table = JSON.parse(JSON.stringify(othis.data_table_t));
          

          this.dialogue_ADD = false;
      })
      .catch(() => {
        console.log("PB soumission d un nouveau Item");
        this.dialogue_ADD = false;
      });

      

    },
    Update_Item(){

     const othis = this;
  
     this.axios.put( backend_url + "/SYS1/neo_acq_f/update/"+this.ligne.id,this.ligne)
      .then((res) => {

          othis.data_table_t = JSON.parse(JSON.stringify(res.data));
          this.data_table = JSON.parse(JSON.stringify(othis.data_table_t));

          this.dialogue_EDIT = false;
      })
      .catch((error) => {
        console.log(error);
        console.log("PB mise à jours d'un Item");
        this.dialogue_EDIT = false;
      });

    }

  }
}
</script>